import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const buyers = [{
  name: 'María L.',
  city: 'Buenos Aires'
}, {
  name: 'Carlos R.',
  city: 'Córdoba'
}, {
  name: 'Luciana M.',
  city: 'Rosario'
}, {
  name: 'Fernando G.',
  city: 'Mendoza'
}, {
  name: 'Soledad P.',
  city: 'La Plata'
}, {
  name: 'Pablo D.',
  city: 'Tucumán'
}, {
  name: 'Valentina S.',
  city: 'Mar del Plata'
}, {
  name: 'Andrés F.',
  city: 'Salta'
}, {
  name: 'Gabriela T.',
  city: 'CABA'
}, {
  name: 'Ricardo N.',
  city: 'Neuquén'
}, {
  name: 'Florencia B.',
  city: 'Santa Fe'
}, {
  name: 'Eduardo K.',
  city: 'San Juan'
}];
export function PopUps() {
  const [currentBuyer, setCurrentBuyer] = useState<(typeof buyers)[0] | null>(null);
  const [timeAgo, setTimeAgo] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [hasScrolledPastFold, setHasScrolledPastFold] = useState(false);
  // Track scroll — only allow popups after user scrolls past first viewport
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > window.innerHeight * 0.35) {
        setHasScrolledPastFold(true);
      }
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const showNextToast = useCallback(() => {
    // Don't show if user hasn't scrolled past fold
    if (!hasScrolledPastFold) {
      // Retry in 5 seconds
      setTimeout(showNextToast, 5000);
      return;
    }
    const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
    const randomTime = Math.floor(Math.random() * 14) + 2;
    setCurrentBuyer(randomBuyer);
    setTimeAgo(randomTime);
    setIsVisible(true);
    // Hide after 5 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Next toast: 25–40 seconds
      const nextDelay = Math.floor(Math.random() * 15000) + 25000;
      setTimeout(showNextToast, nextDelay);
    }, 5000);
  }, [hasScrolledPastFold]);
  useEffect(() => {
    // Initial delay: 15 seconds
    const initialTimeout = setTimeout(() => {
      showNextToast();
    }, 15000);
    return () => clearTimeout(initialTimeout);
  }, [showNextToast]);
  return <AnimatePresence data-id="element-223">
      {isVisible && currentBuyer && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-6 left-6 z-50 bg-card-bg rounded-xl shadow-[0_8px_30px_rgb(0,0,0,0.12)] border border-gold/10 p-3.5 pr-5 flex items-center gap-3 max-w-xs" data-id="element-224">
          <div className="w-9 h-9 rounded-full bg-primary-bg border border-gold/20 flex items-center justify-center shrink-0" data-id="element-225">
            <span className="text-gold font-bold text-sm" data-id="element-226">
              {currentBuyer.name.charAt(0)}
            </span>
          </div>

          <div data-id="element-227">
            <p className="text-sm text-text-primary leading-tight" data-id="element-228">
              <span className="font-bold" data-id="element-229">{currentBuyer.name}</span> de{' '}
              {currentBuyer.city} acaba de comprar.
            </p>
            <div className="flex items-center gap-1 mt-0.5" data-id="element-230">
              <CheckCircle2Icon className="w-3 h-3 text-green-600" data-id="element-231" />
              <span className="text-xs text-text-muted" data-id="element-232">
                Hace {timeAgo} minutos
              </span>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}